import { useApi } from '@hooks/useApi';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';

export function useResendMerchantUserInvitation(merchantId: string) {
  const { query } = useApi();
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: (id: string): Promise<{ message: string }> => {
      return query({
        path: `v1/acquirer/merchants/${merchantId}/users/${id}/invitations/resend`,
        opt: {
          method: 'GET',
        },
      });
    },
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: [...queryKeys.merchantUsers, merchantId] });
    },
  });

  return {
    mutate,
    isPending,
  };
}
